module.exports = __webpack_public_path__ + "img/phone.46a429d1.png";